import firebase from 'firebase';
const config = {
  apiKey: "AIzaSyCosJiNcQn1TVSyMqjrsPJF2RndRFy0mzY",
  authDomain: "wheresmyart-ec3dc.firebaseapp.com",
  databaseURL: "https://wheresmyart-ec3dc.firebaseio.com",
  projectId: "wheresmyart-ec3dc",
  storageBucket: "wheresmyart-ec3dc.appspot.com",
  messagingSenderId: "612451132385",
  appId: "1:612451132385:web:d901c6d51e281f1f"
};
firebase.initializeApp(config);
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const firebaseAuth = firebase.auth;
export const db = firebase.firestore();